import { render, staticRenderFns } from "./FileMenu.vue?vue&type=template&id=1950da2d&scoped=true"
import script from "./FileMenu.vue?vue&type=script&lang=js"
export * from "./FileMenu.vue?vue&type=script&lang=js"
import style0 from "./FileMenu.vue?vue&type=style&index=0&id=1950da2d&prod&scoped=true&lang=css"
import style1 from "./FileMenu.vue?vue&type=style&index=1&id=1950da2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950da2d",
  null
  
)

export default component.exports